import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "./Logo";

export const Loader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const DURATION = 1500;
    const t0 = performance.now();
    let raf;
    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      setProgress(100);
      setTimeout(() => { setDone(true); onComplete?.(); }, 300);
    };
    const step = (now) => {
      const p = Math.min(100, Math.round(((now - t0) / DURATION) * 100));
      setProgress(p);
      if (p < 100) raf = requestAnimationFrame(step);
      else finish();
    };
    raf = requestAnimationFrame(step);
    // Guaranteed completion even if rAF is throttled/paused.
    const safety = setTimeout(finish, DURATION + 250);
    return () => { cancelAnimationFrame(raf); clearTimeout(safety); };
  }, [onComplete]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#050505]"
          exit={{ opacity: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <Logo size={96} animate />
          </motion.div>

          <div className="mt-12 w-[200px] sm:w-[240px]">
            <div className="flex items-center justify-between mb-3">
              <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/40">Rui Guimarães</span>
              <span className="font-mono text-[11px] text-flame tabular-nums">{progress}%</span>
            </div>
            <div className="h-[2px] w-full bg-white/10 overflow-hidden rounded-full">
              <motion.div className="h-full bg-flame" style={{ width: `${progress}%` }} transition={{ ease: "linear" }} />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
